// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d7446e4a","548":"f56b5086","782":"e8607a36"}[chunkId] + ".chunk.js";
};